var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-container"},[_c('div',{ref:"scrollText",staticClass:"scroll-text"},[_vm._v(" "+_vm._s(_vm.allBreakingNews)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }